/** Give up on editor boot/save requests so a dead network cannot spin forever. */
export const EDITOR_NETWORK_TIMEOUT_MS = 5000

/** Chapter content PATCH must outlive the API broker requestTimeout (30 s). */
export const EDITOR_PATCH_TIMEOUT_MS = 35_000

/** Delay before verifying server contentHash after a save that followed a timed-out PATCH. */
export const EDITOR_POST_SAVE_VERIFY_DELAY_MS = 35_000

export const LOCAL_PERSIST_DEBOUNCE_MAX_WAIT_MS = 2_000
export const CHAPTER_UPLOAD_DEBOUNCE_MAX_WAIT_MS = 10_000
